import { TableSortIconArrowDown, TableSortIconArrowUp, TableSortIconSort } from './TableSortIcon';

// TODO: in v9, move styled() from TableSortIcon.jsx to here
export var StyledTableSortIconArrowDown = TableSortIconArrowDown;
export var StyledTableSortIconArrowUp = TableSortIconArrowUp;
export var StyledTableSortIconSort = TableSortIconSort;